import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../access/auth.service';
import { Product } from '../../models/product-v2';
import { Subsidiary } from '../../models/subsidiary';
import { FindProductPriceResponse, PriceServiceProxy } from '../../pages/members/price/services/price.service';
import { SubsidiaryService } from '../../pages/members/subsidiary/services/subsidiary.service';
import { MessageService } from '../../util/message.service';
import { ProductV2Service } from '../../pages/members/product-v2/services/product.v2.service';



@Component({
    selector: 'product-price-card',
    templateUrl: './product-price-card.component.html',
    styleUrls: ['./product-price-card.component.scss']
})
export class ProductPriceCardComponent {
    @Input() id: string | undefined;
    storeId!: string;
    product!: Product;
    prices: FindProductPriceResponse[] = [];
    branches: Subsidiary[] = [];
    imageLoaded = false;
    isExpanded = false;
    constructor(
        public _auth: AuthService,
        private readonly _service: PriceServiceProxy,
        private readonly _messageService: MessageService,
        private readonly _productService: ProductV2Service,
        private readonly _branchService: SubsidiaryService,
        private readonly _route: Router
    ) {
        this.storeId = this._auth.getStore().storeId;
    }
    ngOnInit() {
        if (this.id) {
            this._productService.get(this.storeId, this.id).subscribe({
                next: (res) => {

                    this.product = res;
                },
                error: (e) => {
                    this._messageService.error(`Ha ocurrido un error inesperado, ${e.message}`)
                },
                complete: () => {
                    this.setBranches();
                }
            })
            this._service.findActivePrices(this.storeId, this.id).subscribe({
                next: (res) => {
                    this.prices = res;
                },
                error: (e) => {
                    this._messageService.error(`Ha ocurrido un error inesperado, ${e.message}`)
                }
            })

        }
    }

    setBranches() {
        this._branchService.list(this.storeId, 1, 10).subscribe({
            next: (res: any) => {
                if (res) {
                    this.product.pricing.branches.map(x => x.name = res.result.find(y => y.storeSubsidiaryId == x.id)?.label || "");

                }
            },
            error: (e) => {
                this._messageService.error(`Ha ocurrido un error inesperado, ${e.message}`)
            }
        })
    }

    onEdit(id: string) {
        this._route.navigate([`/members/price/detail-price/${id}`])
    }
}